<script setup lang="ts">
  const version = __APP_VERSION__
  const companyNameLong = import.meta.env.VITE_APP_COMPANY_NAME_LONG
  const releaseYear = import.meta.env.VITE_APP_RELEASE_YEAR ?? new Date().getFullYear()
  import svg from '@/assets/images/rain.svg'

  const copyrightYear = () => {
    if (new Date().getFullYear() === releaseYear) {
      return releaseYear + '-' + new Date().getFullYear()
    }

    return releaseYear
  }
</script>

<template>
  <div class="relative min-h-144 h-screen">
    <div class="bg-auth"></div>
    <div class="inset-0 absolute flex-center">
      <div class="card max-w-[calc(100vw-48px)] w-sm">
        <div class="block rounded-full p-1 overflow-hidden mx-auto w-24 bg-white h-24 shadow-lg -mb-12 -translate-y-12">
          <div class="rounded-full p-1 flex-center bg-primary size-full">
            <img
              :src="svg"
              :alt="'logo ' + companyNameLong">
          </div>
        </div>

        <app-router-view />
      </div>
    </div>
    <div class="absolute text-xs text-center text-white inset-x-0 bottom-4">
      v{{ version }}. &copy;{{ copyrightYear() }} {{ companyNameLong }}
    </div>
  </div>
</template>

<style scoped>
  .bg-auth {
    background-image: url("@/assets/images/bg-auth.jpg");
    background-size: cover;
    background-position: center;
    position: fixed;
    inset: 0;
  }
</style>
